import React, { Component } from 'react';
import _ from 'lodash';

class AssetsTable extends Component {
	componentDidMount = () => {};
	render() {
		return (
			<>
				<div
					className="main-bod"
					style={{
						width: '30vw',
						minWidth: '419px',
					}}
				>
					<table
						className="memoryCardSumaryTable"
						style={{
							borderLeft: '0.5px solid  #383838',
							borderTop: '0.5px solid  #383838',
							color: 'white',
							width: '30vw',
							minWidth: '419px',
						}}
					>
						<tr>
							<th
								style={{
									fontSize: '13px',
									fontWeight: '500',
									color: '#898989',
								}}
							>
								ASSET TYPE
							</th>
							<th
								style={{
									fontSize: '13px',
									fontWeight: '500',
									color: '#898989',
								}}
							>
								TOTAL
							</th>
							<th
								style={{
									fontSize: '13px',
									fontWeight: '500',
									color: '#898989',
								}}
							>
								ACTIVE
							</th>
							<th
								style={{
									fontSize: '13px',
									fontWeight: '500',
									color: '#898989',
								}}
							>
								INACTIVE
							</th>
							<th
								style={{
									fontSize: '13px',
									fontWeight: '500',
									color: '#898989',
								}}
							>
								DAMAGE
							</th>
						</tr>
						{this.props.data.map((el) => {
							return (
								<tr
									onClick={() => {
										this.props.handleSummaryClick(el.type);
									}}
								>
									<td
										style={{
											textTransform: 'capitalize',
											backgroundColor: '',
										}}
									>
										{_.size(
											_.filter(this.props.assetTypeOptions, {
												value: el.type,
											}),
										) > 0
											? _.filter(this.props.assetTypeOptions, {
													value: el.type,
											  })[0]['label']
											: el.type}
									</td>
									<td>{el.totalCount}</td>
									<td
										style={{
											color: '#329B50',
										}}
									>
										{el.activeCount}
									</td>
									<td>{el.inactiveCount}</td>
									<td
										style={{
											color: '#FF1717',
										}}
									>
										{el.damagedCount}
									</td>
								</tr>
							);
						})}

						{/* {_.map(
							_.orderBy(this.props.data, ['type', 'size'], ['asc', 'desc']),
							(data, key) => {
								return (
									<tr>
										<td>
											{data.type} - {data.size}
										</td>
										<td
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													null,
													null,
												)
											}
										>
											{data.total}
										</td>
										<td
											style={{ color: '#479A5F' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'ready',
													'ready',
												)
											}
										>
											{this.readyCount(data.type, data.size)}
										</td>
										<td
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													null,
												)
											}
										>
											{this.busyCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#589ABB' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'inShoot',
												)
											}
										>
											{this.inShootCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#CA4F40' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'copyPending',
												)
											}
										>
											{this.copyPendingCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#E2793A' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'verificationPending',
												)
											}
										>
											{this.verificationPendingCount(data.type, data.size)}
										</td>
										<td
											style={{ color: '#EBC658' }}
											onClick={() =>
												this.props.handleSummaryClick(
													data.type,
													data.size,
													'busy',
													'releasePending',
												)
											}
										>
											{this.releasePendingCount(data.type, data.size)}
										</td>
									</tr>
								);
							},
						)} */}
					</table>
				</div>
			</>
		);
	}
}
export default AssetsTable;
